export default "__VITE_ASSET__B$09Ztyy__"